import { render } from "./OpenDiagnosisPanel.vue?vue&type=template&id=dfc106a6"
import script from "./OpenDiagnosisPanel.vue?vue&type=script&lang=js"
export * from "./OpenDiagnosisPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__